// browser info
export const isOpera = (navigator.userAgent.indexOf('Opera') || navigator.userAgent.indexOf('OPR')) !== -1;
export const isFirefox = navigator.userAgent.indexOf('Firefox') !== -1;
export const isIE = navigator.userAgent.indexOf('MSIE') !== -1;
export const isChrome = navigator.userAgent.indexOf('Chrome') !== -1;
export const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

export const currentUserKey = sessionStorage.getItem('isCustView') === 'YES' ? 'custViewUser' : 'currentUser';
export const currentNavTab = 'currenttabs';
export const spogTokenKey = 'spogToken';
